import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  contractFindAllSagaAction,
  myAccountSagaActionType,
  updateContractSagaActionPayloadType,
} from "./saga-actions";
import { axiosGraphqlInstance, axiosRestInstance } from "../../../common/axios";
import { myAccountSliceAction } from "../../slices/my-account";
import { AxiosResponse } from "axios";
import { insertCartIDSagaActions } from "../cart/saga-actions";
import { RootStateType } from "../..";
import {
  ContractType,
  OrderDetailType,
  OrderListType,
} from "../../slices/my-account/Types";

type contractFindAllAPIResponseType = {
  success: boolean;
  message: string;
  data: ContractType[];
};

const contractFindAllAPI = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<contractFindAllAPIResponseType>>(
      `/contracts/getcontractsforpartner/${ID}`
    )
    .then((res) => res.data);
  return response;
};

type updateContractAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};

const updateContractAPI = (payload: updateContractSagaActionPayloadType) => {
  let response = axiosRestInstance
    .put<AxiosResponse<updateContractAPIResponseType>>(
      `/contracts/futureDateUpdate/${payload.ID}`,
      {
        startDate: payload.startDate,
        nextDate: payload.endDate,
        salesforce_opportunity: payload.salesforce_opportunity,
        oracle_channel: payload.oracle_channel,
      }
    )
    .then((res) => res.data);
  return response;
};

type allOrdersByPartnerAPIResponseType = {
  success: boolean;
  message: string;
  data: OrderListType[];
};
const allOrdersByPartnerAPI = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<allOrdersByPartnerAPIResponseType>>(
      `/order/listOrder/${ID}`
    )
    .then((res) => res.data);
  return response;
};

type orderDetailAPIResponse = {
  success: boolean;
  message: string;
  data: OrderDetailType;
};
const orderDetailAPI = async (orderId: string) => {
  const orderIDArray = orderId.split("/");
  let response = axiosRestInstance
    .get<AxiosResponse<orderDetailAPIResponse>>(
      `/order/${orderIDArray[orderIDArray.length - 1]}`
    )
    .then((res) => res.data);
  return response;
};

// type fetchCustomerDetailAPIResponseType = {
//   data: {
//     customer: {
//       id: string;
//       displayName: string;
//       firstName: string;
//       lastName: string;
//       email: string;
//       phone: string;
//       defaultAddress: {
//         company: string;
//       };
//     };
//   };
// };
// const fetchCustomerDetailAPI = async (customerAccessToken: string) => {
//   let response = axiosGraphqlInstance
//     .post<AxiosResponse<fetchCustomerDetailAPIResponseType>>("/graphql.json", {
//       query: ` {
//           customer(customerAccessToken: "${customerAccessToken}") {
//             id
//             displayName
//             firstName
//             lastName
//             email
//             phone
//             defaultAddress {
//               company
//             }
//           }
//         }
//         `,
//       variables: {},
//     })
//     .then((response) => response?.data);
//   return response;
// }

// type CustomerUpdatePayloadType = {
//   id: string;
//   email: string;
//   phone: string;
//   firstName: string;
//   lastName: string;
// }
// type updateCustomerAPIResponseType = {
//   success?: boolean;
//   message: string;
//   result?: any;
// }
// const updateCustomerAPI = (customerUpdatePayload: CustomerUpdatePayloadType) => {
//   let response = axiosRestInstance
//     .post<AxiosResponse<updateCustomerAPIResponseType>>(
//       "/api/update-customer",
//       customerUpdatePayload
//     )
//     .then((res) => res.data);
//   return response;
// };

type boldSubscriptionAPIResponseType = {
  status: boolean;
  message: string;
  data?: string;
};
const activateBoldSubscriptionAPI = async (subscriptionId: string) => {
  let response = axiosRestInstance
    .post<AxiosResponse<boldSubscriptionAPIResponseType>>(
      `/api/subscription/activate/${subscriptionId}`
    )
    .then((res) => res.data);
  return response;
};
const pauseBoldSubscriptionAPI = async (subscriptionId: string) => {
  let response = axiosRestInstance
    .post<AxiosResponse<boldSubscriptionAPIResponseType>>(
      `/api/subscription/pause/${subscriptionId}`
    )
    .then((res) => res.data);
  return response;
};

// ---- ALL API ABOVE AND SAGA BELOW ----

function* contractFindAllSaga(actions: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(myAccountSliceAction.setContractsLoadingStatus(true));
    yield put(
      myAccountSliceAction.setFetchedContractsPartnerID(actions.payload.ID)
    );
    let response: contractFindAllAPIResponseType = yield call(
      contractFindAllAPI,
      actions.payload.ID
    );
    response.data.sort(
      (a, b) =>
        new Date(b.start_date).getTime() - new Date(a.start_date).getTime()
    );
    yield put(myAccountSliceAction.setContracts(response.data));
    yield put(myAccountSliceAction.setContractsLoadingStatus(false));
  } catch (e) {
    yield put(myAccountSliceAction.setContracts([]));
    yield put(myAccountSliceAction.setContractsLoadingStatus(false));
    console.log(e);
  }
}

// function* fetchCustomerDetailSaga(actions: { type: string }) {
//   try {
//     yield put(myAccountSliceAction.setCustomerDetailLoadingStatus(true));
//     let customerAccessToken = localStorage.getItem("user-token");
//     const response: fetchCustomerDetailAPIResponseType = yield call(
//       fetchCustomerDetailAPI,
//       customerAccessToken
//     );
//     yield put(myAccountSliceAction.setCustomerDetailLoadingStatus(false));
//   } catch (e) {
//     yield put(myAccountSliceAction.setCustomerDetailLoadingStatus(false));
//     console.log(e);
//   }
// }

function* allOrdersSaga(actions: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(myAccountSliceAction.setOrderHistoryLoadingStatus(true));
    yield put(
      myAccountSliceAction.setFetchedOrdersPartnerID(actions.payload.ID)
    );
    let response: allOrdersByPartnerAPIResponseType = yield call(
      allOrdersByPartnerAPI,
      actions.payload.ID
    );
    response.data?.sort(
      (a, b) =>
        new Date(b.processedAt).getTime() - new Date(a.processedAt).getTime()
    );
    yield put(myAccountSliceAction.setAllOrders(response.data));
    yield put(myAccountSliceAction.setOrderHistoryLoadingStatus(false));
  } catch (e) {
    yield put(myAccountSliceAction.setAllOrders([]));
    yield put(myAccountSliceAction.setOrderHistoryLoadingStatus(false));
    console.log(e);
  }
}

function* updateContractSaga(actions: {
  type: string;
  payload: updateContractSagaActionPayloadType;
}) {
  try {
    yield put(myAccountSliceAction.setUpdateContractLoadingStatus(true));
    let response: updateContractAPIResponseType = yield call(
      updateContractAPI,
      actions.payload
    );
    yield put(contractFindAllSagaAction(actions.payload.partnerID));
    yield put(myAccountSliceAction.setUpdateContractLoadingStatus(false));
    actions.payload.setModalOpen(false);
    yield;
  } catch (e) {
    yield put(myAccountSliceAction.setUpdateContractLoadingStatus(false));
    console.log(e);
  }
}

function* orderDetailSaga(actions: {
  type: string;
  payload: {
    orderId: string;
  };
}) {
  try {
    yield put(myAccountSliceAction.setOrderDetailLoadingStatus(true));
    let response: orderDetailAPIResponse = yield call(
      orderDetailAPI,
      actions.payload.orderId
    );
    yield put(myAccountSliceAction.setOrderDetail(response.data));
    yield put(myAccountSliceAction.setOrderDetailLoadingStatus(false));
  } catch (e) {
    console.log(e);
    yield put(myAccountSliceAction.setOrderDetailLoadingStatus(false));
  }
}

type orderDetailPDFSagaActionPayloadType = {
  orderId: string;
  generatePdfDocumentFunction: (orderDetailPdfData: OrderDetailType) => void;
};
function* orderDetailPDFSaga(actions: {
  type: string;
  payload: orderDetailPDFSagaActionPayloadType;
}) {
  try {
    yield put(
      myAccountSliceAction.setOrderDetailPDFID(actions.payload.orderId)
    );
    yield put(myAccountSliceAction.setOrderDetailPDFLoadingStatus(true));
    let response: orderDetailAPIResponse = yield call(
      orderDetailAPI,
      actions.payload.orderId
    );
    yield put(myAccountSliceAction.setOrderDetailPDF(response.data));
    yield put(myAccountSliceAction.setOrderDetailPDFLoadingStatus(false));
    yield call(actions?.payload?.generatePdfDocumentFunction, response?.data);
  } catch (e) {
    console.log(e);
    yield put(myAccountSliceAction.setOrderDetailPDFLoadingStatus(false));
  }
}

// function* updateCustomerSaga(actions: {
//   type: string;
//   payload: CustomerUpdatePayloadType;
// }) {
//   try {
//     yield put(myAccountSliceAction.setCustomerUpdateLoadingStatus(true));
//     let response: updateCustomerAPIResponseType = yield call(
//       updateCustomerAPI,
//       actions.payload
//     );
//     yield put(myAccountSliceAction.setCustomerUpdateLoadingStatus(false));
//   } catch (e) {
//     yield put(myAccountSliceAction.setCustomerUpdateLoadingStatus(false));
//     console.log(e);
//   }
// }

function* activateBoldSubscriptionSaga(actions: {
  type: string;
  payload: {
    subscriptionId: string;
  };
}) {
  try {
    yield put(
      myAccountSliceAction.setSubscriptionID(actions.payload.subscriptionId)
    );
    yield put(myAccountSliceAction.setSubscriptionLoading(true));
    let response: boldSubscriptionAPIResponseType = yield call(
      activateBoldSubscriptionAPI,
      actions.payload.subscriptionId
    );

    const selectContracts = (state: RootStateType) => state.my_account;
    const { contracts } = yield select(selectContracts);
    const updatedContracts = contracts.map((contract: ContractType) => {
      if (contract.subscription_id === actions.payload.subscriptionId)
        return { ...contract, subscription_status: response.data };
      else return contract;
    });
    yield put(myAccountSliceAction.setContracts(updatedContracts));
    yield put(myAccountSliceAction.setSubscriptionLoading(false));
  } catch (e) {
    yield put(myAccountSliceAction.setSubscriptionLoading(false));
    console.log(e);
  }
}

function* pauseBoldSubscriptionSaga(actions: {
  type: string;
  payload: {
    subscriptionId: string;
  };
}) {
  try {
    yield put(
      myAccountSliceAction.setSubscriptionID(actions.payload.subscriptionId)
    );
    yield put(myAccountSliceAction.setSubscriptionLoading(true));
    let response: boldSubscriptionAPIResponseType = yield call(
      pauseBoldSubscriptionAPI,
      actions.payload.subscriptionId
    );

    const selectContracts = (state: RootStateType) => state.my_account;
    const { contracts } = yield select(selectContracts);
    const updatedContracts = contracts.map((contract: ContractType) => {
      if (contract.subscription_id === actions.payload.subscriptionId)
        return { ...contract, subscription_status: response.data };
      else return contract;
    });
    yield put(myAccountSliceAction.setContracts(updatedContracts));
    yield put(myAccountSliceAction.setSubscriptionLoading(false));
  } catch (e) {
    yield put(myAccountSliceAction.setSubscriptionLoading(false));
    console.log(e);
  }
}

function* myAccountSaga() {
  yield takeLatest(
    myAccountSagaActionType.callContractFindAllSaga,
    contractFindAllSaga
  );
  yield takeLatest(myAccountSagaActionType.callAllOrdersSaga, allOrdersSaga);
  yield takeLatest(
    myAccountSagaActionType.callOrderDetailSaga,
    orderDetailSaga
  );
  yield takeLatest(
    myAccountSagaActionType.callUpdateContractSaga,
    updateContractSaga
  );
  yield takeLatest(
    myAccountSagaActionType.callOrderDetailPDFSaga,
    orderDetailPDFSaga
  );
  yield takeLatest(
    myAccountSagaActionType.callActivateBoldSubscriptionSaga,
    activateBoldSubscriptionSaga
  );
  yield takeLatest(
    myAccountSagaActionType.callPauseBoldSubscriptionSaga,
    pauseBoldSubscriptionSaga
  );
}

export default myAccountSaga;
